import { setUnauthorizedCallback } from "../api/client";
import { useAuthEtablissementStore } from "./authEtablissementStore";

/** Initialise la session établissement avant toute route protégée. */
export async function initAuthEtablissement() {
  setUnauthorizedCallback(() => {
    useAuthEtablissementStore.getState().clearAuth();
  });
  useAuthEtablissementStore.setState({ isLoading: true });
  await useAuthEtablissementStore.getState().initAuth();
}
